import { useSelector } from 'react-redux';
import { useMediaPredicate } from 'react-media-hook';
import { MOBILE_SIZE } from 'utils/mediaQueryUtils';
import { getLabelFromValue } from 'pages/backendSearch/backendSearchConstants';
import { DataSetSelectMobile } from 'pages/backendSearch/DataSetSelect';

const BackendSearchControls = ({ onSearch, page, setPage, searchTerm, onSelectDataSet, selectedDataSet, setSearchTerm }) => {
	const isMobile = useMediaPredicate(MOBILE_SIZE);
	const {
		isLoading,
		data,
	} = useSelector(state => ({
		isLoading: state.recordSearch.isLoading,
		data: state.recordSearch.data || [],
	}));

	// Handle input change - allow any search term
	const handleInputChange = (e) => {
		setSearchTerm(e.target.value);
	};

	const goToPage = (e) => {
		const pageNum = parseInt(e.target.value);
		if (pageNum > 0 && !isNaN(pageNum)) {
			setPage(pageNum);
		}
	}

	const onEnter = (event) => {
		if (event.key === 'Enter') {
      onSearch();
    }
	};

	const onNext = () => {
		setPage(page + 1);
		onSearch(page + 1);
	}

	const onPrevious = () => {
		if (page > 1) {
			setPage(page - 1);
			onSearch(page - 1);
		}
	}

	// Rendered below once pagination is re-enabled (currently commented out)
	// eslint-disable-next-line no-unused-vars
	let pageButtons = (
		<div className="page-buttons-container">
			<button key="prev" className="btn btn-primary" onClick={onPrevious} disabled={isLoading || page <= 1}>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
				Previous
			</button>
			<div className="page-input-wrapper">
				<span className="page-label">Page</span>
				<input type="number" className="form-control page-input" value={page} onChange={goToPage} onKeyPress={onEnter} disabled={isLoading} />
			</div>
			<button key="next" className="btn btn-primary" onClick={onNext} disabled={isLoading || !data?.length}>
				Next
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</button>
		</div>
	);

	let searchInput = (
		<div className="input-group search-input-group">
			<div className="search-icon-wrapper">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
					<path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</div>
			<input
				type="text"
				className="form-control search-input"
				placeholder={`Search ${getLabelFromValue(selectedDataSet)}...`}
				value={searchTerm}
				onChange={handleInputChange}
				onKeyPress={onEnter}
			/>
			<button
				className="btn btn-primary search-button"
				onClick={() => { onSearch(); }}
				disabled={!searchTerm || !selectedDataSet || isLoading}
			>
				{isLoading ? (
					<>
						<svg className="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="31.416" strokeDashoffset="31.416">
								<animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
								<animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
							</circle>
						</svg>
						Searching...
					</>
				) : (
					<>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M14.5 14.5L11.5 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
						Search
					</>
				)}
			</button>
		</div>
	);
	return (
		<div className="backend-search-controls">
			{isMobile ? <DataSetSelectMobile selectedDataSet={selectedDataSet} onSelect={onSelectDataSet} /> : null}
			{searchInput}
			{/* {pageButtons} */}
		</div>
	);
};

export default BackendSearchControls;